/* Boba Charge storefront behaviour — Shopify build.
   The static preview faked a cart in the URL hash. Here every cart operation
   goes through Shopify's AJAX Cart API and every form is a real Shopify form,
   so nothing is simulated. */
(function () {
  "use strict";
  var BC2_I18N = (window.bc2 && window.bc2.i18n) || {};
  var BC2_EN = {"add_fail": "Could not add to cart", "update_fail": "Could not update the cart", "added": "Added", "empty": "Your cart is empty.", "you_save": "You save ", "dec": "Decrease quantity", "inc": "Increase quantity", "remove": "Remove", "discount": "Discount", "total": "Total", "subtotal": "Subtotal", "your_cart": "Your cart", "added_to_cart": "Added to cart", "over_500": "over 500 sessions", "session": " session", "sessions": " sessions", "over_5y": "over 5 years", "month": " month", "months": " months"};
  function T(k) { return BC2_I18N[k] != null ? BC2_I18N[k] : BC2_EN[k]; }

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var num = function (el, attr, fallback) {
    if (!el) return fallback;
    var v = parseFloat(el.getAttribute(attr));
    return isNaN(v) ? fallback : v;
  };
  /* Money in the visitor's own currency. Liquid renders 123456 through the
     store's money filter (window.bc2.moneySample, e.g. "$1,234.56", "£1,234.56",
     "1.234,56 kr") and this copies its symbol and separators. */
  var BC2_MS = (window.bc2 && window.bc2.moneySample) || "$1,234.56";
  var BC2_MM = BC2_MS.match(/1([^0-9]?)234([^0-9])56/);
  var BC2_TS = BC2_MM ? BC2_MM[1] : ",", BC2_DS = BC2_MM ? BC2_MM[2] : ".";
  var BC2_TPL = BC2_MM ? BC2_MS.replace(BC2_MM[0], "\u0000") : "$\u0000";
  function bc2Money(cents, whole) {
    var v = Math.abs(cents || 0) / 100;
    var s = whole ? String(Math.round(v)) : v.toFixed(2);
    var parts = s.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, BC2_TS);
    return BC2_TPL.replace("\u0000", parts.join(BC2_DS));
  }
  window.bc2Money = bc2Money;
  var round = function (n) {
    var r = Math.round(n);
    var sign = r < 0 ? "\u2212" : "";
    return sign + bc2Money(Math.abs(r) * 100, true);
  };

  /* Money formatting uses the shop's own format string, injected by Liquid. */
  var MONEY_FORMAT = (window.bc2 && window.bc2.moneyFormat) || "${{amount}}";
  function money(cents) { return bc2Money(cents); }

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  /* ---------------- Toast ---------------- */
  var toastT;
  function toast(msg) {
    var t = $("[data-toast]");
    if (!t) { return; }
    var m = $("[data-toast-msg]", t);
    if (m) m.textContent = msg;
    t.hidden = false;
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.hidden = true; }, 2600);
  }

  /* ---------------- Cart count ---------------- */
  function paintCount(n) {
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      if (n) el.removeAttribute("data-empty"); else el.setAttribute("data-empty", "");
    });
  }

  function refreshCount() {
    return fetch(ROOT + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paintCount(c.item_count); return c; })
      .catch(function () { });
  }

  /* ---------------- Add to cart (AJAX, real variants) ----------------
     Any form posting to /cart/add is intercepted. Checked [data-up] upsell
     inputs carry a real variant id and ride along in the same request. */
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || form.tagName !== "FORM") return;
    var action = form.getAttribute("action") || "";
    if (action.indexOf("/cart/add") === -1) return;
    if (form.hasAttribute("data-no-ajax")) return;
    /* Only handle Boba Charge custom sections. Base-theme product pages have
       their own product-form-component handler — intercepting those caused the
       item to be added twice. */
    if (!form.closest(".bc2-root")) return;
    if (form.closest("product-form-component")) return;

    var idField = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
    if (!idField || !idField.value) return; /* let Shopify report the error */

    e.preventDefault();

    var qtyField = form.querySelector('[name="quantity"]');
    var items = [{
      id: parseInt(idField.value, 10),
      quantity: Math.max(1, parseInt(qtyField && qtyField.value, 10) || 1)
    }];

    $$('input[name="upsell_variant_ids[]"], [data-up-id]', form).forEach(function (cb) {
      if (!cb.checked || cb.disabled) return;
      var vid = parseInt(cb.getAttribute("data-up-id") || cb.value, 10);
      if (vid) items.push({ id: vid, quantity: 1 });
    });

    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute("aria-busy", "true"); btn.disabled = true; }

    fetch(ROOT + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.body.description || res.body.message || T("add_fail")); return; }
        var label = (res.body.items && res.body.items[0] && res.body.items[0].product_title) || T("added");
        LAST_ADDED = 1;
        openDrawer(res.body && res.body.items ? null : null);
        $$('input[name="upsell_variant_ids[]"], [data-up-id]', form).forEach(function (cb) { cb.checked = false; });
        return refreshCount();
      })
      .catch(function () { toast(T("add_fail")); })
      .then(function () { if (btn) { btn.removeAttribute("aria-busy"); btn.disabled = false; } });
  });

  /* ---------------- Cart page line changes (AJAX) ----------------
     Rows are server-rendered by Liquid. The steppers post to /cart/change.js
     and reload so totals, discounts and shipping stay authoritative. The
     remove control and the "updates[...]" inputs also work with JS disabled. */
  function changeLine(line, quantity) {
    return fetch(ROOT + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () { toast(T("update_fail")); });
  }

  document.addEventListener("click", function (e) {
    var el = e.target.closest && e.target.closest("[data-cart-qty-up], [data-cart-qty-down]");
    if (!el) return;
    e.preventDefault();
    var line = parseInt(el.getAttribute("data-line"), 10);
    var q = parseInt(el.getAttribute("data-quantity"), 10);
    if (isNaN(line) || isNaN(q)) return;
    changeLine(line, Math.min(20, Math.max(0, q)));
  });

  /* ---------------- Announcement height, so the header can pin cleanly ---- */
  function measureAnnounce() {
    var a = $("[data-announce]");
    var h = a ? a.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty("--bc2-ann-h", h.toFixed(1) + "px");
  }
  measureAnnounce();
  window.addEventListener("resize", measureAnnounce);

  /* ---------------- Reveal on scroll ---------------- */
  window.bc2Revealed = true;
  var reveals = $$(".bc2-reveal");
  if (reveals.length && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("bc2-is-in"); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add("bc2-is-in"); });
  }

  /* ---------------- Mobile drawer ---------------- */
  var drawer = $("[data-drawer]");
  if (drawer) {
    var openBtn = $("[data-drawer-open]");
    var close = function () {
      drawer.hidden = true;
      if (openBtn) { openBtn.setAttribute("aria-expanded", "false"); openBtn.focus(); }
    };
    if (openBtn) openBtn.addEventListener("click", function () {
      drawer.hidden = false;
      openBtn.setAttribute("aria-expanded", "true");
      var x = $("[data-drawer-close]", drawer);
      if (x) x.focus();
    });
    var closeBtn = $("[data-drawer-close]");
    if (closeBtn) closeBtn.addEventListener("click", close);
    drawer.addEventListener("click", function (e) { if (e.target === drawer) close(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !drawer.hidden) close(); });
  }

  /* ---------------- Earnings calculators ----------------
     Both the homepage estimator and the compact PDP estimator render their
     assumptions as data attributes driven by section settings, so the merchant
     retunes them in the Theme Editor rather than in code. Element ids are
     queried inside each calculator root, so two can coexist on one page. */
  var DEFAULT_WPM = 4.333;

  function attr(el, names, fallback) {
    for (var i = 0; i < names.length; i++) {
      if (el.hasAttribute(names[i])) {
        var v = parseFloat(el.getAttribute(names[i]));
        if (!isNaN(v)) return v;
      }
    }
    return fallback;
  }

  /* Guard against a cents value reaching a dollars field. A residential or
     commercial charger is never $5,000+ and an electricity rate is never
     $1.00+/kWh, so a value above those thresholds is a unit mismatch. */
  function dollars(v, ceiling) {
    if (window.bc2 && window.bc2.currency && window.bc2.currency !== "USD") return v;
    return v > ceiling ? v / 100 : v;
  }

  $$("[data-unit-price]").forEach(function (box) {
    /* s1 = sessions per week, s2 = the owner's electricity COST per kWh in
       cents, s3 = the PRICE the owner charges guests per kWh in cents. kWh per
       session is a fixed assumption, not a slider. */
    var s1 = box.querySelector("#s1"), s2 = box.querySelector("#s2"), s3 = box.querySelector("#s3");
    if (!s1 || !s3) return;

    var price = dollars(attr(box, ["data-unit-price"], 399.99), 5000);
    var kwh = attr(box, ["data-kwh-per-session"], 80);
    var feePct = attr(box, ["data-fee-percent"], 10) / 100;
    var fallbackCost = dollars(attr(box, ["data-kwh-cost", "data-elec-rate"], 0.17), 1);
    var wpm = attr(box, ["data-weeks-per-month"], DEFAULT_WPM);
    var out = function (id) { return box.querySelector("#" + id); };
    var money2 = function (v) { return (v < 0 ? "\u2212" : "") + bc2Money(Math.round(Math.abs(v) * 100)); };

    var calc = function () {
      var sess = +s1.value;
      var kwhCost = s2 ? +s2.value / 100 : fallbackCost;
      var rate = +s3.value / 100;
      if (out("v1")) out("v1").textContent = sess;
      if (out("v2")) out("v2").textContent = money2(kwhCost);
      if (out("v3")) out("v3").textContent = money2(rate);
      if (out("costrate")) out("costrate").textContent = money2(kwhCost);
      var monthly = sess * kwh * wpm;
      var rev = monthly * rate;
      var spend = monthly * kwhCost;
      var fee = rev * feePct;
      var net = rev - spend - fee;
      if (out("rev")) out("rev").textContent = round(rev);
      if (out("cost")) out("cost").textContent = "\u2212" + round(spend);
      if (out("fee")) out("fee").textContent = "\u2212" + round(fee);
      if (out("net")) out("net").textContent = round(net);
      if (out("pay")) {
        var perSession = sess > 0 ? net / sess : 0;
        var n = perSession > 0 ? Math.ceil(price / perSession) : 0;
        out("pay").textContent = net <= 0 || perSession <= 0 ? "\u2014" : n > 500 ? T("over_500") : n + (n === 1 ? T("session") : T("sessions"));
      }
    };
    [s1, s2, s3].forEach(function (el) { if (el) el.addEventListener("input", calc); });
    calc();
  });

  /* ---------------- Commercial multi-unit ROI ---------------- */
  $$("[data-roi-unit-price]").forEach(function (box) {
    var c1 = box.querySelector("#c1"), c2 = box.querySelector("#c2"), c3 = box.querySelector("#c3");
    if (!c1 || !c2 || !c3) return;

    var unit = dollars(attr(box, ["data-roi-unit-price"], 699.99), 5000);
    var kwhCost = dollars(attr(box, ["data-roi-elec-rate", "data-kwh-cost"], 0.17), 1);
    var kwh = attr(box, ["data-roi-kwh"], 30);
    var wpm = attr(box, ["data-weeks-per-month"], DEFAULT_WPM);
    var out = function (id) { return box.querySelector("#" + id); };

    var calc = function () {
      var units = +c1.value, sess = +c2.value, rate = +c3.value / 100;
      if (out("cv1")) out("cv1").textContent = units;
      if (out("cv2")) out("cv2").textContent = sess;
      if (out("cv3")) out("cv3").textContent = bc2Money(Math.round(rate * 100));
      var monthly = units * sess * kwh * wpm;
      var rev = monthly * rate, spend = monthly * kwhCost, net = rev - spend, hw = units * unit;
      if (out("crev")) out("crev").textContent = round(rev);
      if (out("ccost")) out("ccost").textContent = "\u2212" + round(spend);
      if (out("cnet")) out("cnet").textContent = round(net);
      if (out("chw")) out("chw").textContent = round(hw);
      if (out("cpay")) {
        var m = net > 0 ? Math.ceil(hw / net) : 0;
        out("cpay").textContent = net <= 0 ? "\u2014" : m > 60 ? T("over_5y") : m + (m === 1 ? T("month") : T("months"));
      }
    };
    [c1, c2, c3].forEach(function (el) { el.addEventListener("input", calc); });
    calc();
  });

  /* ---------------- PDP gallery ---------------- */
  var galImg = $("[data-gal-img]");
  if (galImg) {
    $$(".bc2-gal__t[data-src]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        galImg.src = btn.getAttribute("data-src");
        if (btn.getAttribute("data-srcset")) galImg.srcset = btn.getAttribute("data-srcset");
        $$(".bc2-gal__t").forEach(function (b) {
          b.classList.remove("bc2-is-on");
          b.setAttribute("aria-selected", "false");
        });
        btn.classList.add("bc2-is-on");
        btn.setAttribute("aria-selected", "true");
      });
    });
  }

  /* ---------------- Variant (batch) picker ----------------
     The radios are name="id" carrying real variant ids, so the form submits
     correctly even without JS. This only syncs the visible price and dates. */
  var batch = $("[data-batch]");
  if (batch) {
    var shipText = $("[data-ship-text]");
    var priceEls = $$("[data-variant-price]");
    var compareEls = $$("[data-variant-compare]");
    var stickyShip = $("[data-sticky-ship]");
    var stickyPrice = $("[data-sticky-price]");

    var syncVariant = function (input) {
      if (!input) return;
      $$(".bc2-batch__o", batch).forEach(function (l) { l.classList.remove("bc2-is-on"); });
      var label = input.closest(".bc2-batch__o");
      if (label) label.classList.add("bc2-is-on");

      var ship = input.getAttribute("data-ship") || "";
      if (shipText && ship) shipText.textContent = ship;
      if (stickyShip && ship) stickyShip.textContent = ship;

      var cents = parseInt(input.getAttribute("data-price"), 10);
      if (!isNaN(cents)) {
        priceEls.forEach(function (el) { el.textContent = money(cents); });
        if (stickyPrice) stickyPrice.textContent = money(cents);
      }
      var cmp = parseInt(input.getAttribute("data-compare"), 10);
      compareEls.forEach(function (el) {
        if (!isNaN(cmp) && cmp > cents) { el.textContent = money(cmp); el.hidden = false; }
        else { el.hidden = true; }
      });
    };

    batch.addEventListener("change", function (e) {
      var input = e.target.closest && e.target.closest('input[name="id"]');
      if (input) syncVariant(input);
    });
    syncVariant(batch.querySelector('input[name="id"]:checked'));
  }

  /* ---------------- Quantity stepper (PDP) ---------------- */
  var qtyBox = $("[data-qty]");
  if (qtyBox) {
    var qin = $("[data-qty-input]", qtyBox);
    var step = function (d) {
      var v = Math.min(20, Math.max(1, (parseInt(qin.value, 10) || 1) + d));
      qin.value = v;
    };
    var up = $("[data-qty-up]", qtyBox);
    var down = $("[data-qty-down]", qtyBox);
    if (up) up.addEventListener("click", function () { step(1); });
    if (down) down.addEventListener("click", function () { step(-1); });
    if (qin) qin.addEventListener("change", function () { step(0); });
  }

  /* ---------------- Sticky buy bar ---------------- */
  var sticky = $("[data-sticky]");
  if (sticky) {
    var anchor = $(".bc2-qty-row");
    if (anchor && "IntersectionObserver" in window) {
      new IntersectionObserver(function (en) {
        sticky.hidden = en[0].isIntersecting || en[0].boundingClientRect.top > 0;
      }, { threshold: 0 }).observe(anchor);
    }
  }

  /* ---------------- Boot ---------------- */
  paintCount(window.bc2 && typeof window.bc2.itemCount === "number" ? window.bc2.itemCount : 0);

  /* ---------------- Slide-out cart ---------------- */
  var DRAWER = null, LAST_ADDED = null;
  function money(cents) { return (cents < 0 ? "-" : "") + bc2Money(cents); }
  function esc(t) { var d = document.createElement("div"); d.textContent = t == null ? "" : String(t); return d.innerHTML; }

  function drawerEl() { if (!DRAWER) DRAWER = $("[data-cdrawer]"); return DRAWER; }

  function renderDrawer(cart) {
    var d = drawerEl(); if (!d) return;
    var wrap = $("[data-cdrawer-items]", d);
    var items = (cart && cart.items) || [];
    if (!items.length) {
      wrap.innerHTML = '<p class="bc2-cdrawer__empty">' + esc(T("empty")) + '</p>';
    } else {
      wrap.innerHTML = items.map(function (i, idx) {
        var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") : "";
        var vt = i.variant_title && i.variant_title !== "Default Title" ? i.variant_title : "";
        var orig = i.original_line_price != null ? i.original_line_price : i.line_price;
        var fin = i.final_line_price != null ? i.final_line_price : i.line_price;
        var saved = orig - fin;
        var codes = (i.line_level_discount_allocations || []).map(function (a) { return a.discount_application && a.discount_application.title; })
          .filter(function (t, k, arr) { return t && arr.indexOf(t) === k; }).join(", ");
        return '<div class="bc2-cditem" data-line="' + (idx + 1) + '">' +
          (img ? '<img class="bc2-cditem__img" src="' + esc(img) + '" alt="" width="72" height="72">' : '<span class="bc2-cditem__img"></span>') +
          '<div class="bc2-cditem__b">' +
            '<a class="bc2-cditem__t" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' +
            (vt ? '<span class="bc2-cditem__v">' + esc(vt) + '</span>' : '') +
            (saved > 0 ? '<span class="bc2-cditem__save">' + (codes ? esc(codes) + ': ' : '') + esc(T("you_save")) + money(saved) + '</span>' : '') +
            '<div class="bc2-cditem__r">' +
              '<span class="bc2-cdqty">' +
                '<button type="button" data-dq="-" aria-label="' + esc(T("dec")) + '">&minus;</button>' +
                '<b>' + i.quantity + '</b>' +
                '<button type="button" data-dq="+" aria-label="' + esc(T("inc")) + '">+</button>' +
              '</span>' +
              '<b class="bc2-cditem__p">' + (saved > 0 ? '<s class="bc2-cditem__was">' + money(orig) + '</s> ' : '') + money(fin) + '</b>' +
            '</div>' +
            '<button type="button" class="bc2-cditem__x" data-dremove>' + esc(T("remove")) + '</button>' +
          '</div>' +
        '</div>';
      }).join("");
    }
    /* Accessory upsell: only when a residential charger is in the cart, and
       only for accessories that are not already in the cart. */
    var RESID = ["boba-residential-240v-ev-charger", "boba-residential-230v-ev-charger"]; /* PowerGuard fits the 240V plug-in only */
    var handles = items.map(function (i) { return i.handle; });
    var up = $("[data-cdup]", d);
    if (up) {
      var wantsUpsell = handles.some(function (h) { return RESID.indexOf(h) !== -1; });
      var shown = 0;
      $$("[data-cdup-row]", up).forEach(function (row) {
        var inCart = handles.indexOf(row.getAttribute("data-cdup-h")) !== -1;
        row.hidden = inCart;
        if (!inCart) shown++;
      });
      up.hidden = !(wantsUpsell && shown);
    }
    var total = $("[data-cdrawer-total]", d); if (total) total.textContent = money(cart && cart.total_price);
    var disc = (cart && cart.total_discount) || 0;
    var oRow = $("[data-cdrawer-orig]", d), dRow = $("[data-cdrawer-disc]", d), tLab = $("[data-cdrawer-tlabel]", d);
    if (oRow && dRow && tLab) {
      var allCodes = [];
      items.forEach(function (i) { (i.line_level_discount_allocations || []).forEach(function (a) { var t = a.discount_application && a.discount_application.title; if (t && allCodes.indexOf(t) === -1) allCodes.push(t); }); });
      ((cart && cart.cart_level_discount_applications) || []).forEach(function (a) { if (a.title && allCodes.indexOf(a.title) === -1) allCodes.push(a.title); });
      oRow.hidden = dRow.hidden = !(disc > 0 && items.length);
      if (disc > 0) {
        $("b", oRow).textContent = money(cart.original_total_price);
        $("span", dRow).textContent = T("discount") + (allCodes.length ? " (" + allCodes.join(", ") + ")" : "");
        $("b", dRow).textContent = "\u2212" + money(disc);
      }
      tLab.textContent = disc > 0 && items.length ? T("total") : T("subtotal");
    }
    var title = $("[data-cdrawer-title]", d);
    if (title) title.textContent = !items.length ? T("your_cart") : (LAST_ADDED ? T("added_to_cart") : T("your_cart"));
    var go = $(".bc2-cdrawer__go", d); if (go) go.hidden = !items.length;
  }

  function openDrawer(cart) {
    var d = drawerEl();
    if (!d) { window.location.href = (window.bc2 && window.bc2.cartUrl) || ROOT + "cart"; return; }
    /* Show the panel immediately, then fill it. */
    d.hidden = false;
    document.documentElement.classList.add("bc2-noscroll");
    setTimeout(function () { d.classList.add("bc2-cdrawer--in"); }, 16);
    if (cart && cart.items) { renderDrawer(cart); return; }
    var wrap = $("[data-cdrawer-items]", d);
    if (wrap && !wrap.children.length) wrap.innerHTML = '<p class="bc2-cdrawer__empty">Loading your cart\u2026</p>';
    fetch(ROOT + "cart.js", { headers: { Accept: "application/json" }, cache: "no-store" })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderDrawer(c); })
      .catch(function () {
        if (wrap) wrap.innerHTML = '<p class="bc2-cdrawer__empty">Your item was added. <a href="' + ((window.bc2 && window.bc2.cartUrl) || "/cart") + '">View cart</a></p>';
      });
  }
  function closeDrawer() {
    var d = drawerEl(); if (!d) return;
    d.classList.remove("bc2-cdrawer--in");
    document.documentElement.classList.remove("bc2-noscroll");
    setTimeout(function () { d.hidden = true; }, 240);
    LAST_ADDED = null;
  }
  window.bc2Drawer = { open: openDrawer, close: closeDrawer };

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-cdrawer-close]")) { e.preventDefault(); closeDrawer(); return; }
    var cartLink = e.target.closest('a[href$="/cart"], a[href*="/cart?"], [data-cart-open]');
    if (cartLink && !e.target.closest(".bc2-cdrawer") && !e.metaKey && !e.ctrlKey) {
      var inFooter = e.target.closest(".bc2-ftr");
      if (!inFooter) { e.preventDefault(); LAST_ADDED = null; openDrawer(); }
      return;
    }
    var qb = e.target.closest("[data-dq]");
    if (qb) {
      var row = qb.closest("[data-line]");
      var cur = parseInt($("b", $(".bc2-cdqty", row)).textContent, 10) || 1;
      var next = qb.getAttribute("data-dq") === "+" ? cur + 1 : cur - 1;
      changeLine(row.getAttribute("data-line"), Math.max(0, next));
      return;
    }
    var rm = e.target.closest("[data-dremove]");
    if (rm) { changeLine(rm.closest("[data-line]").getAttribute("data-line"), 0); return; }
    var ua = e.target.closest("[data-cdup-add]");
    if (ua) {
      var vid = parseInt(ua.getAttribute("data-cdup-add"), 10);
      var dd = drawerEl(); if (dd) dd.classList.add("bc2-cdrawer--busy");
      ua.disabled = true;
      _fetch(ROOT + "cart/add.js", {
        method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
      }).then(function () { return _fetch(ROOT + "cart.js", { headers: { Accept: "application/json" }, cache: "no-store" }); })
        .then(function (r) { return r.json(); })
        .then(function (c) { LAST_ADDED = null; renderDrawer(c); refreshCount(); })
        .catch(function () {})
        .then(function () { ua.disabled = false; if (dd) dd.classList.remove("bc2-cdrawer--busy"); });
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { var d = drawerEl(); if (d && !d.hidden) closeDrawer(); }
  });
  function changeLine(line, qty) {
    var d = drawerEl(); if (d) d.classList.add("bc2-cdrawer--busy");
    fetch(ROOT + "cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { LAST_ADDED = null; renderDrawer(cart); refreshCount(); })
      .catch(function () {})
      .then(function () { if (d) d.classList.remove("bc2-cdrawer--busy"); });
  }

  /* Any add-to-cart on the site — ours or the base theme's — opens the drawer. */
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    var p = _fetch.apply(this, arguments);
    if (!isAdd) return p;
    return p.then(function (res) {
      if (res && res.ok) { LAST_ADDED = 1; setTimeout(function () { openDrawer(); refreshCount(); }, 260); }
      return res;
    });
  };
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (f && f.tagName === "FORM" && (f.getAttribute("action") || "").indexOf("/cart/add") !== -1) {
      if (!f.closest(".bc2-root") && !f.closest("product-form-component")) {
        /* Non-AJAX fallback form: let it post, drawer opens on the next page. */
        try { sessionStorage.setItem("bc2OpenCart", "1"); } catch (err) {}
      }
    }
  }, true);
  try { if (sessionStorage.getItem("bc2OpenCart")) { sessionStorage.removeItem("bc2OpenCart"); LAST_ADDED = 1; setTimeout(function () { openDrawer(); }, 400); } } catch (err) {}

})();

